/**
 * 站内 Link chokepoint：href 经 toStaticExportHref，禁止业务直接用 react-router Link。
 * 在 Router 外（单测 / 静态壳）降级为原生 <a>。
 */

import {
  Link as RouterLink,
  useInRouterContext,
  type LinkProps as RouterLinkProps,
} from "react-router";
import { forwardRef, type AnchorHTMLAttributes } from "react";

import { toAppNavigationHref } from "@/config/normalize-application-pathname";

export type AppLinkProps = Omit<RouterLinkProps, "to" | "prefetch"> &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
    href: string;
    /** Next.js compatibility; ignored in the SPA. */
    prefetch?: boolean;
  };

function isExternalHref(href: string): boolean {
  return (
    /^https?:\/\//i.test(href) ||
    href.startsWith("//") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  );
}

export const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>(
  function AppLink({ href, prefetch: _prefetch, ...rest }, ref) {
    const to = toAppNavigationHref(href);
    const inRouter = useInRouterContext();

    if (!inRouter || isExternalHref(to)) {
      return <a ref={ref} href={to} {...rest} />;
    }
    return <RouterLink ref={ref} to={to} {...rest} />;
  },
);
